import React, {Component} from 'react';
import ModalWrapper from "./ModalWrapper";
import './styles/AAFModalDeviceChangeKaon.scss'
import Translator from "../../requests/apa/Translator";
import Utils from "../../utils/Utils";

class AAFModalDeviceChangeKaon extends Component {
  constructor(props) {
    super(props);
    this.keysMetadata = {
      title: "Alerta_CambioDeco_Kaon_Titulo_Texto",
      text1: "Alerta_CambioDeco_Kaon_Parrafo_Texto1",
      text2: "Alerta_CambioDeco_Kaon_Parrafo_Texto2",
      text3: "Alerta_CambioDeco_Kaon_Parrafo_Texto3",
      text4: "Alerta_CambioDeco_Kaon_Parrafo_Texto4",
      text5: "Alerta_CambioDeco_Kaon_Parrafo_Texto5",
      text6: "Alerta_CambioDeco_Kaon_Parrafo_Texto6",
      text7: "Alerta_CambioDeco_Kaon_Parrafo_Texto7",
      text8: "Alerta_CambioDeco_Kaon_Parrafo_Texto8",
      text9: "Alerta_CambioDeco_Kaon_Parrafo_Texto9",
      text10: "Alerta_CambioDeco_Kaon_Parrafo_Texto10",
    };
    this.state = {
      text: {
        title: Translator.get(this.keysMetadata.title),
        text1: Translator.get(this.keysMetadata.text1),
        text2: Translator.get(this.keysMetadata.text2),
        text3: Translator.get(this.keysMetadata.text3),
        text4: Translator.get(this.keysMetadata.text4),
        text5: Translator.get(this.keysMetadata.text5),
        text6: Translator.get(this.keysMetadata.text6),
        text7: Translator.get(this.keysMetadata.text7),
        text8: Translator.get(this.keysMetadata.text8),
        text9: Translator.get(this.keysMetadata.text9),
        text10: Translator.get(this.keysMetadata.text10),
      },
      numChars: {
        title: 48,
      }
    };
  }

  cutString() {
    const texts = this.state.text;
    const numChars = this.state.numChars;
    const keysTexts = Object.keys(texts);

    keysTexts.forEach((key) => {
      if (texts[key] !== this.keysMetadata[key] && numChars[key]) {
        texts[key] = Utils.cutPlayerString(texts[key], numChars[key], null, "...");
      }
    });

    return texts
  }

  truncateTexts(texts, maxLength) {
    // "remaining" lleva la cuenta de cuántos caracteres aún podemos usar
    let remaining = maxLength;

    return texts.map((text, index) => {
      // CASO 1: Ya no quedan caracteres disponibles
      // Retornamos null para descartar este texto
      if (remaining <= 0) {
        return null;
      }

      // CASO 2: El texto completo cabe en lo que queda
      // Lo retornamos íntegro y restamos su longitud (+1 por el espacio)
      if (text.length <= remaining) {
        remaining -= text.length;
        return text;
      }

      // CASO 3: El texto NO cabe completo
      // Lo cortamos hasta donde alcance y agregamos "..."
      // Se resta uno para que los puntos caigan dentro del límite
      const truncated = Utils.cutPlayerString(text, remaining, (remaining - 3), "...");
      remaining = 0; // Ya no queda espacio para más textos
      return truncated;
    }).filter(Boolean); // Elimina todos los valores null del array
  };

  createParagraphs(texts, classNamePrefix, startIndex) {
    return texts.map((text, index) => {
      const key = index + startIndex;
      return (
        <p
          key={`${classNamePrefix}_text-${key}`}
          className={`${classNamePrefix}_text-${key}`}>{text}</p>
      )
    });
  }

  render() {
    const {
      title = "",
      text1 = "",
      text2 = "",
      text3 = "",
      text4 = "",
      text5 = "",
      text6 = "",
      text7 = "",
      text8 = "",
      text9 = "",
      text10 = ""
    } = this.cutString();
    const displayTextsMessage = this.truncateTexts([`${text1} `, `${text2} `, `${text3} `, `${text4} `, `${text5}`], 170);
    const firstPart = displayTextsMessage.slice(0, 3);
    const secondPart = displayTextsMessage.slice(3);
    const displayTextsInfo = this.truncateTexts([`${text6} `, `${text7} `, `${text8} `, `${text9} `, `${text10}`], 170);

    return (
      <ModalWrapper className={"modal_change_device_kaon"}>
        <div className={"modal_change_device_kaon-content"}>
          <div className={"modal_change_device_kaon-title"}>
            <p className={"kaon-title_text"}>{title}</p>
          </div>
          <div className={"modal_change_device_kaon-messages"}>
            <div className={"modal_change_device_kaon-message"}>
              <div>
                {
                  firstPart
                  && firstPart.length > 0
                  && this.createParagraphs(firstPart, "kaon-message", 1)
                }
              </div>

              <div>
                {
                  secondPart
                  && secondPart.length > 0
                  && this.createParagraphs(secondPart, "kaon-message", 4)
                }
              </div>
            </div>
            <div className={"modal_change_device_kaon-information"}>
              {
                displayTextsInfo
                && displayTextsInfo.length > 0
                && this.createParagraphs(displayTextsInfo, "kaon-information", 6)
              }
            </div>
          </div>
        </div>
      </ModalWrapper>
    )
  }
}

export default AAFModalDeviceChangeKaon;



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalDeviceChangeKaon.jsx